import { Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";

import * as Yup from "yup";
import GlobalSettingsApi from "../../../api/GlobalSettingsApi";
import { appConstants } from "../../../config/app-constants";
import {
  EToastvariant,
  IGeneralSettingForm,
  IGlobalSettingsRoot
} from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { showToastMsg } from "../../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../../services";
import { ButtonSpinner } from "../../placeholders";

// Validation Schema of General Setting
const generalFormSchema = Yup.object().shape({
  admin_email: Yup.string()
    .email("Invalid email address")
    .trim()
    .matches(appConstants.EMAIL_REGEX, "Invalid email address")
    .required("Admin email is required")
});

const GeneralSettings = () => {
  const dispatch = useAppDispatch();
  const [generalSettingData, setGeneralSettingData] = useState<IGlobalSettingsRoot>();

  useEffect(() => {
    getGeneralSetting();
  }, []);

  // Get CookiesPolicy Value
  const getGeneralSetting = async () => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const response = await api.getGlobalSettingByKey("ADMIN_EMAIL");
      setGeneralSettingData(response.data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    }
  };

  const initialGeneralFormValues: IGeneralSettingForm = {
    admin_email: generalSettingData?.value || ""
  };

  // handle Submit of General setting
  const handleGeneralFormSubmit = async (
    value: IGeneralSettingForm,
    { setSubmitting }: FormikHelpers<IGeneralSettingForm>
  ): Promise<void> => {
    try {
      const api = GlobalSettingsApi.getInstance();
      const _value: any = {
        value: value.admin_email
      };
      let _msg = `General settings added successfully.`;
      if (generalSettingData?.uuid) {
        await api.updateGlobalSettings(generalSettingData?.uuid, _value);
        _msg = `General settings updated successfully.`;
      } else {
        _value.key = "ADMIN_EMAIL";
        await api.createGlobalSettings(_value);
      }

      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: _msg,
          variant: EToastvariant.Success
        })
      );
      // dispatch(fetchGlobalSettings());
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialGeneralFormValues}
        validationSchema={generalFormSchema}
        onSubmit={handleGeneralFormSubmit}
      >
        {({ handleSubmit, isSubmitting, handleChange, values, errors, handleBlur, touched }) => (
          <>
            <Card className="form-card tab-card">
              <Card.Body>
                <Row className="justify-content-center">
                  <Col xs={12} sm={10} md={8} lg={6} xl={4}>
                    <Form.Group className="form-group" controlId="admin_email">
                      <Form.Label className="required-field">Admin email</Form.Label>
                      <Form.Control
                        size="lg"
                        type="email"
                        placeholder="john@email.com"
                        name="admin_email"
                        value={values.admin_email}
                        onBlur={handleBlur("admin_email")}
                        onChange={handleChange("admin_email")}
                        isInvalid={Boolean(errors.admin_email) && touched.admin_email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.admin_email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="form-btns-wrap text-center">
                  <Button
                    variant="primary"
                    type="button"
                    size="lg"
                    className="btn-w-160 text-white"
                    onClick={() => handleSubmit()}
                  >
                    {!isSubmitting ? "Save" : <ButtonSpinner />}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </>
        )}
      </Formik>
    </>
  );
};

export default GeneralSettings;
